import "./Receipes.scss";
import PreviousSearches from "../PreviousSearches/PreviousSearches";
import RecipesCard from "../RecipesCard/RecipesCard";

function Receipes() {
  const recipes = [
    {
      title: "Chicken Pizza",
      image:
        "https://images.unsplash.com/photo-1618213837799-25d5552820d3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1142&q=80",
      authorImg:
        "https://www.parkregisgoa.in/wp-content/uploads/2020/04/chef-video-placeholder@2x-624x600.jpg",
    },
    {
      title: "Spaghetti and Meatballs",
      image:
        "https://images.unsplash.com/photo-1677139599935-67eb22b12bb1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
      authorImg:
        "https://c0.wallpaperflare.com/preview/539/724/1000/beard-chef-cook-cuisine.jpg",
    },
    {
      title: "American Cheese Burger",
      image:
        "https://images.unsplash.com/photo-1571091718767-18b5b1457add?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80",
      authorImg:
        "https://news.uga.edu/wp-content/uploads/2022/11/ChefJorgeNoriega-07-Square.jpg",
    },
    {
      title: "Mutton Biriyani",
      image:
        "https://www.cubesnjuliennes.com/wp-content/uploads/2020/06/Mutton-Biryani-Recipe.jpg",
      authorImg:
        "https://nationaltoday.com/wp-content/uploads/2021/07/shutterstock_1518533924-min.jpg",
    },
    {
      title: "Japanese Sushi",
      image:
        "https://images.unsplash.com/photo-1553621042-f6e147245754?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80",
      authorImg:
        "https://www.onlinedegree.com/wp-content/uploads/2016/11/master_chef.jpg",
    },
    {
      title: "PanCake",
      image:
        "https://images.unsplash.com/photo-1565299543923-37dd37887442?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=781&q=80",
      authorImg: "https://www.ecpi.edu/sites/default/files/Aug%2022%20CIV.png",
    },
    {
      title: "Fried chicken",
      image:
        "https://images.unsplash.com/photo-1562967916-eb82221dfb92?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=686&q=80",
      authorImg:
        "https://www.parkregisgoa.in/wp-content/uploads/2020/04/chef-video-placeholder@2x-624x600.jpg",
    },
    {
      title: "Muffin",
      image:
        "https://images.unsplash.com/photo-1599785209615-a35f883d93c8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1173&q=80",
      authorImg:
        "https://nationaltoday.com/wp-content/uploads/2021/07/shutterstock_1518533924-min.jpg",
    },
    {
      title: "Taco",
      image:
        "https://images.unsplash.com/photo-1615870216519-2f9fa575fa5c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1032&q=80",
      authorImg:
        "https://news.uga.edu/wp-content/uploads/2022/11/ChefJorgeNoriega-07-Square.jpg",
    },

    {
      title: "Dal Makhani",
      image:
        "https://myfoodstory.com/wp-content/uploads/2018/08/Dal-Makhani-New-3-500x500.jpg",
      authorImg:
        "https://c0.wallpaperflare.com/preview/539/724/1000/beard-chef-cook-cuisine.jpg",
    },
    {
      title: "Beef Stroganoff",
      image:
        "https://images.unsplash.com/photo-1644592219048-5c070fd3c91c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=961&q=80",
      authorImg:
        "https://news.uga.edu/wp-content/uploads/2022/11/ChefJorgeNoriega-07-Square.jpg",
    },
    {
      title: "Waldorf Salad",
      image:
        "https://www.eatthis.com/wp-content/uploads/sites/4/2019/02/waldorf-salad.jpg?resize=640,468&quality=82&strip=all",
      authorImg:
        "https://nationaltoday.com/wp-content/uploads/2021/07/shutterstock_1518533924-min.jpg",
    },
    {
      title: "Salisbury Steak",
      image:
        "https://www.eatthis.com/wp-content/uploads/sites/4/2019/02/salisbury-steak.jpg?resize=640,468&quality=82&strip=all",
      authorImg:
        "https://www.onlinedegree.com/wp-content/uploads/2016/11/master_chef.jpg",
    },
    {
      title: "Buffalo Wings",
      image:
        "https://www.eatthis.com/wp-content/uploads/sites/4/2016/10/buffalo-wings.jpg?resize=640,468&quality=82&strip=all",
      authorImg:
        "https://www.parkregisgoa.in/wp-content/uploads/2020/04/chef-video-placeholder@2x-624x600.jpg",
    },
    {
      title: "Kung Pao Chicken",
      image:
        "https://www.eatthis.com/wp-content/uploads/sites/4/2019/02/kung-pao-chicken.jpg?resize=640,468&quality=82&strip=all",
      authorImg:
        "https://news.uga.edu/wp-content/uploads/2022/11/ChefJorgeNoriega-07-Square.jpg",
    },
  ];

  return (
    <div>
      <PreviousSearches />
      <div className="recipes-container">
        {recipes.map((recipe, index) => (
          <RecipesCard key={index} recipes={recipe} />
        ))}
      </div>
    </div>
  );
}

export default Receipes;
